import React from 'react';

export default function Dashboard() {
  return (
    <div className="min-h-screen rounded-lg bg-white dark:bg-gray-800 px-5 py-6 shadow-sm sm:px-6 dark:text-gray-100 transition-colors duration-300">
      {/* Dashboard content */}
      <div className="py-8">
        <h2 className="text-xl font-semibold mb-4">Welcome to the Dashboard</h2>
        <p>Select an option from the navigation menu to get started.</p>
      </div>
    </div>
  );
}